/**
 * Reference-counted page scroll lock for overlays (BottomSheet, SidePanel).
 * Several can be open at once (PreauthKeysPage nests reveal-after-create; a
 * sheet can open over the side panel); the lock is released when the *last*
 * one closes.
 *
 * Compensates for the disappearing scrollbar by adding `padding-right`
 * equal to the scrollbar width — without this, every element on the
 * page underneath the sheet shifts horizontally when the sheet opens
 * and shifts back when it closes (looks like a janky reflow).
 */
let scrollLockCount = 0;
let savedBodyOverflow = '';
let savedBodyPaddingRight = '';
export function acquireScrollLock() {
    scrollLockCount += 1;
    if (scrollLockCount > 1)
        return;
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    savedBodyOverflow = document.body.style.overflow;
    savedBodyPaddingRight = document.body.style.paddingRight;
    document.body.style.overflow = 'hidden';
    if (scrollbarWidth > 0) {
        document.body.style.paddingRight = `${scrollbarWidth}px`;
    }
}
export function releaseScrollLock() {
    scrollLockCount = Math.max(0, scrollLockCount - 1);
    if (scrollLockCount > 0)
        return;
    document.body.style.overflow = savedBodyOverflow;
    document.body.style.paddingRight = savedBodyPaddingRight;
}
